import styled from 'styled-components';

export const Section = styled.section`
  padding: 32px 0;

  &:first-of-type {
    padding-top: 0;
  }
`;
